import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SectionHeading from 'components/SectionHeading';
import ContentWrapper from 'components/ContentWrapper';
import ContentItem from 'components/ContentItem';
import CallToAction from 'components/CallToAction';
import Tagline from 'components/Tagline';
import Divider from 'components/Divider';
import styled from 'styled-components';
import { Flex, Box, Text } from 'rebass/styled-components';
import Layout from 'components/Layout';
import PartnerList from 'components/PartnerList';
import { wrapper } from '../services/store';
import { getPosts, getSiteMeta } from '../services/actions';
import { get, without, intersection } from 'lodash';
import { ACCENT1_COLOR } from '../services/constants';

const FilterText = styled(Text)`
  transition: opacity 0.3s ease;
  font-style: italic;
  opacity: ${(props) => (props.active ? '1' : '0.5')};
  cursor: pointer;
  border-bottom: ${(props) =>
    props.active ? `2px solid ${ACCENT1_COLOR}` : 'none'};
  &:hover {
    opacity: 1;
  }
`;

const CategoryFilter = styled(Flex)`
  display: none;
`;

const Work = ({ categories, posts, mediaCategories, tags }) => {
  const [filter, setFilter] = useState([]);

  const toggleFilter = (e, id) => {
    e.preventDefault();
    setFilter([id]);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setFilter([]);
  };

  const workCategory = categories.items.find((t) => t.slug === 'work')?.id;
  const featuredTagId = tags.items.find((t) => t.slug === 'featured')?.id;
  const workCategoryChildren = categories.items.filter(
      (c) => c.parent === workCategory
  );

  const workItems = posts.items.filter((p) =>
      p.categories.includes(workCategory)
  );
  const carouselCategories = mediaCategories.items
      .filter((c) => c.slug === 'carousel')
      .map((c) => c.id);
  const featuredImageCategory = mediaCategories.items
      .filter((c) => c.slug === 'cover')
      .map((c) => c.id)[0];

  let filteredWorkItems = filter.length
      ? workItems.filter((i) =>
          intersection(filter, without(i.categories, workCategory)).length
      )
      : workItems;

  const sortedAndFilteredWorkItems = filteredWorkItems.sort((a, b) => {
    if (a.tags?.includes(featuredTagId)) return -1;
    if (b.tags?.includes(featuredTagId)) return 1;
    return 0;
  });

  return (
      <Layout>
        <ContentWrapper mb={5}>
          <Flex flexDirection="column" p={4}>
            <SectionHeading center>Our Partners</SectionHeading>
            <Tagline textAlign='center'>in crime</Tagline>
            <Divider medium />
            <PartnerList />
          </Flex>
          <Flex flexDirection="column" p={4} pb={0}>
            <SectionHeading center>Our Work</SectionHeading>
            <Tagline center>some of our pride and joy</Tagline>
            <Divider medium />
            <CategoryFilter flexWrap="wrap" mx={-2} justifyContent="center">
              <Box px={2} flex="200px 1 auto">
                <FilterText
                    onClick={(e) => resetFilter(e)}
                    active={!filter.length}
                    textAlign="center"
                >
                  all
                </FilterText>
              </Box>
              {workCategoryChildren.map((item) => (
                  <Box key={item.id} px={2} flex="200px 1 auto">
                    <FilterText
                        onClick={(e) => toggleFilter(e, item.id)}
                        active={filter.includes(item.id)}
                        textAlign="center"
                    >
                      {item.slug}
                    </FilterText>
                  </Box>
              ))}
            </CategoryFilter>
          </Flex>
          <Flex
              textAlign="center"
              justifyContent="center"
              width={1}
              flexWrap="wrap"
          >
            {sortedAndFilteredWorkItems.map((item) => (
                <ContentItem
                    key={item.id}
                    mediaCategories={carouselCategories}
                    featuredImageCategory={featuredImageCategory}
                    {...item}
                />
            ))}
          </Flex>
        </ContentWrapper>
        {/* <ContentWrapper accent $noPadding>
        <CallToAction text={`Ready, Set, Let's Go`} />
      </ContentWrapper> */}
      </Layout>
  );
};

Work.propTypes = {
  categories: PropTypes.shape({
    items: PropTypes.array,
  }),
  posts: PropTypes.shape({
    items: PropTypes.array,
  }),
  mediaCategories: PropTypes.shape({
    items: PropTypes.array,
  }),
  tags: PropTypes.shape({
    items: PropTypes.array,
  }),
};

export const getServerSideProps = wrapper.getServerSideProps(
    (store) => async () => {
      const options = {
        categories: ['work'],
      };
      await store.dispatch(getSiteMeta());
      await store.dispatch(getPosts(options));

      const state = store.getState();
      return {
        props: {
          categories: state.categories,
          posts: state.posts,
          mediaCategories: state.mediaCategories,
          tags: state.tags,
        },
      };
    }
);

export default Work;